import { Component, OnInit, OnChanges, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterLinkActive } from '@angular/router';

import { NavigationNode } from '@app/core';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss']
})
export class NavItemComponent implements OnInit, OnChanges  {
  @Input() level = 1;
  @Input() node: NavigationNode;
  @Input() isParentExpanded = true;
  @Input() selectedNodes: NavigationNode[];

  isExpanded = false;
  isSelected = false;
  classes: { [index: string]: boolean };
  nodeChildren: NavigationNode[];

  constructor(private activatedRoute: ActivatedRoute) {
    
  }

  ngOnInit() {

  }

  ngOnChanges() {

    this.nodeChildren = this.node && this.node.children ? this.node.children.filter(n => !n.hidden) : [];
    //  this.isSelected = this.rla.isActive;
    //  this.isSelected = this.rla.isActive;
    //  this.isExpanded = this.isParentExpanded && this.isSelected;
    //  console.log(this.isSelected + ' - ' + this.node.title + ' - ' + this.node.url + ' - ' + this.rla.isActive);
    if (this.selectedNodes) {
      const ix = this.selectedNodes.indexOf(this.node);
      this.isSelected = ix !== -1; // this node is the selected node or its ancestor
      this.isExpanded = this.isParentExpanded && this.isSelected;
    } else {
      this.isSelected = false;
    }

    this.setClasses();
  }

  setClasses() {
    this.classes = {
      ['level-' + this.level]: true,
      collapsed: !this.isExpanded,
      expanded: this.isExpanded,
      selected: this.isSelected
    };
  }

  headerClicked() {
    // this.selectedNodes.push(this.node);
    this.isExpanded = !this.isExpanded;
    this.setClasses();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/nav-item/nav-item.component.ts